<template>
  <scoped>
    <template v-if="source">
      <video
        :title="title"
        autoplay
        controls
        loop
      >
        <source :src="source">
      </video>
    </template>
    <template v-else>
      <img
        :src="require('@/images/computerinfor_icon.png')"
        :alt="title"
      >
    </template>
  </scoped>
</template>

<script setup lang="ts">
  import {onBeforeMount, ref} from "vue"
  import {File as FileClient} from "@/endpoints/rutsolve/rest/file"

  const props = defineProps({
    data: {
      default: null,
      required: false,
      type: String
    },
    extension: {
      default: null,
      required: false,
      type: String
    },
    title: {
      default: null,
      required: true,
      type: String
    },
    url: {
      default: null,
      required: false,
      type: String
    }
  })

  const source = ref<string>(null)

  onBeforeMount(() => {
    read()
  })

  async function read() {
    if (props.url) {
      source.value = await FileClient.read(props.url)
    } else {
      source.value = `data:video/${props.extension};base64,${props.data}`
    }
  }
</script>
